export enum FormValidationError {
  REQUIRED = 'required',
  MAX_LENGTH = 'maxlength',
  NOT_BLANK_STRING = 'notBlankString',
  INCORRECT_VALUE = 'incorrectValue',
  EMAIL = 'email',
  DUPLICATE = 'duplicate',
  MAT_PICKER_PARSE = 'matDatepickerParse',
}
